var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 7a4 4 0 0 1 7.2-2.4 1 1 0 0 0 1.6-1.2A6 6 0 0 0 6 7v3H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2H8V7zm-4 5h16v8H4v-8z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }